module.exports = __webpack_public_path__ + "img/LogoW.518c4fc8.svg";